module.exports = __webpack_public_path__ + "static/angela_outline-a7e73a9d3506a95066367b8e55976173.png";